var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"videoplayer"}},[_c('video',{attrs:{"controls":"","id":"vidframe","src":"http://video.tu-freiberg.de/getMedium/Default/88f88c1f0ad1fdf743079f777ace3b22.mp4"}}),_vm._v(" "),_c('b-button',{on:{"click":_vm.spring}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aee01b3e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/videoPlayer.vue
// module id = 223
// module chunks = 0